<ng-template #modal let-modal>
  @if (ok) {
  <div>
    <div class="modal-header">
      <h2 class="modal-name">{{ "GENERAL.CONFIGURATION" | translate }}</h2>
      @if (!blockUser) {
      <button
        type="button"
        class="btn-close"
        (click)="modal.close()"
        aria-label="Close"
      ></button>
      }
    </div>
    <!--  tabindex="0" ngbAutofocus -->
    <div class="modal-body">
      <hr />
      <div class="row" style="max-height: 100%; height: 100%">
        <div class="col-12 mt-1" style="max-height: 100%; height: 100%">
          <ng-scrollbar>
            <!-- VERSIÓ ACTUAL de la webapp -->
            <h4 class="mb-1">
              {{ "GENERAL.CURRENT_VERSION" | translate }}: <b>{{ version }}</b>
            </h4>
            <!-- IP -->
            @if (machine) {
            <h5 class="mb-1">
              IP: <b>{{ machine.deviceIp }}</b>
            </h5>
            }
            <!-- Estat de la connexió amb el socket local e-connect -->
            <div class="d-flex align-items-center mb-1">
              <div
                [ngClass]="{
                  'bg-primary': localSocketReadyState == 1,
                  'bg-warning':
                    localSocketReadyState == 0 || localSocketReadyState == 2,
                  'bg-danger': localSocketReadyState == 3
                }"
                class="led me-1"
              ></div>
              @if (localSocketReadyState == 0) {
              <span>
                {{ "GENERAL.CONNECTING" | translate }}
              </span>
              } @if (localSocketReadyState == 1) {
              <span>
                {{ "GENERAL.OPEN" | translate }}
              </span>
              } @if (localSocketReadyState == 2) {
              <span>
                {{ "GENERAL.CLOSING" | translate }}
              </span>
              } @if (localSocketReadyState == 3) {
              <span>
                {{ "GENERAL.CLOSED" | translate }}
              </span>
              }
            </div>
            <div class="my-2"></div>
            <!-- Change URL API -->
            <div class="mb-1">
              <label for="API">URL API:</label>
              <div class="input-group">
                <input
                  showMatKeyboard
                  class="form-control"
                  type="url"
                  id="API"
                  [(ngModel)]="URL_API"
                  placeholder="https://example.com"
                />
                <button
                  class="btn btn-primary"
                  type="button"
                  [disabled]="URL_API == ''"
                  (click)="changeURL_API()"
                  rippleEffect
                >
                  {{ "GENERAL.CHANGE" | translate }}
                </button>
              </div>
            </div>
            <!-- Change URL Web Socket Cloud -->
            <div class="mb-1">
              <label for="WebSocketCloud">URL Web Socket Cloud:</label>
              <div class="input-group">
                <input
                  showMatKeyboard
                  class="form-control"
                  type="url"
                  id="WebSocketCloud"
                  [(ngModel)]="URL_WebSocketCloud"
                  placeholder="https://example.com"
                />
                <button
                  class="btn btn-primary"
                  type="button"
                  [disabled]="URL_WebSocketCloud == ''"
                  (click)="changeURL_WebSocketCloud()"
                  rippleEffect
                >
                  {{ "GENERAL.CHANGE" | translate }}
                </button>
              </div>
            </div>
            <label><hr /></label>
            <!-- Change Configuration Passowrd -->
            <div class="mb-1">
              <label for="ConfigurationPassword"
                >{{ "GENERAL.CONFIGURATION_PASSWORD" | translate }}:</label
              >
              <div class="input-group">
                <span
                  (click)="basicPwdShow = !basicPwdShow"
                  class="input-group-text cursor-pointer"
                  ><i
                    class="feather"
                    [ngClass]="{
                      'icon-eye-off': basicPwdShow,
                      'icon-eye': !basicPwdShow
                    }"
                  ></i
                ></span>
                <input
                  [showMatKeyboard]="'numpad'"
                  class="form-control"
                  [type]="basicPwdShow ? 'text' : 'password'"
                  id="ConfigurationPassword"
                  [(ngModel)]="ConfigurationPassword"
                />
                <button
                  class="btn btn-primary"
                  type="button"
                  [disabled]="ConfigurationPassword == ''"
                  (click)="changeConfigurationPassowrd()"
                  rippleEffect
                >
                  {{ "GENERAL.CHANGE" | translate }}
                </button>
              </div>
            </div>
          </ng-scrollbar>
        </div>
      </div>
    </div>
    <div class="row mt-2 p-1">
      <div class="col-12 d-flex justify-content-end align-items-center">
        @if (!blockUser) {
        <button
          class="btn btn-lg btn-light mb-2"
          type="button"
          (click)="modal.close()"
        >
          {{ "GENERAL.CANCEL" | translate }}
        </button>
        }
      </div>
    </div>
  </div>
  } @if (!ok) {
  <div>
    <div class="modal-header">
      <h2 class="modal-name">{{ "GENERAL.CONFIGURATION" | translate }}</h2>
      @if (!blockUser) {
      <button
        type="button"
        class="btn-close"
        (click)="modal.close()"
        aria-label="Close"
      ></button>
      }
    </div>
    <div class="modal-body">
      <hr />
      <div class="row">
        <div class="col-12 mt-1">
          <label><hr /></label>
          <div class="mb-1">
            <label for="Password"
              >{{ "GENERAL.CONFIGURATION_PASSWORD" | translate }}:</label
            >
            <div class="input-group">
              <span
                (click)="basicPwdShow2 = !basicPwdShow2"
                class="input-group-text cursor-pointer"
                ><i
                  class="feather"
                  [ngClass]="{
                    'icon-eye-off': basicPwdShow2,
                    'icon-eye': !basicPwdShow2
                  }"
                ></i
              ></span>
              <!-- autofocus -->
              <input
                #focusInput
                [showMatKeyboard]="'numpad'"
                class="form-control"
                [type]="basicPwdShow2 ? 'text' : 'password'"
                id="Password"
                [(ngModel)]="password"
                (change)="error = false"
                (keydown.enter)="checkPass()"
              />
              <button
                class="btn btn-primary"
                type="button"
                [disabled]="password == ''"
                (click)="checkPass()"
                rippleEffect
              >
                {{ "GENERAL.LOGIN" | translate }}
              </button>
            </div>
          </div>
          @if (error) {
          <span class="mt-2 text-danger">{{
            "GENERAL.INCORRECT_PASSWORD" | translate
          }}</span>
          }
        </div>
      </div>
    </div>
    <div class="row mt-2 p-1">
      <div class="col-12 d-flex justify-content-end align-items-center">
        @if (!blockUser) {
        <button
          class="btn btn-lg btn-light mb-1"
          type="button"
          (click)="modal.close()"
        >
          {{ "GENERAL.CANCEL" | translate }}
        </button>
        }
      </div>
    </div>
  </div>
  }
</ng-template>
